import { Injectable } from '@angular/core';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service'
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';

@Injectable({
  providedIn: 'root'
})
export class CompetenceDataService {

  constructor(private dataProvider: DataService) { }

  async getCompetence(status:number): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetCompetence,status).toPromise();
  }

  
  addCompetence(model: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.AddCompetence, model).toPromise();
  }

  async getCompetenceById(id: number): Promise<any> 
  {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetCompetenceById, id).toPromise();
  }

  updateCompetence(Model : any ) : Promise<any> {
    return this.dataProvider.Put<GenericResponse<any>>(Urls.EditCompetence, Model).toPromise();
  }
  
  deleteCompetence(id:any): Promise<any> {
    return this.dataProvider.Delete<GenericResponse<any>>(Urls.DeleteCompetence,id).toPromise();
  }
}
